import React from "react";
import { Helmet } from "react-helmet-async";

const SalemPageSeo = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://www.nawabicaterers.com/best-catering-services-in-salem",
        "url": "https://www.nawabicaterers.com/best-catering-services-in-salem",
        "name": "Best Catering Services in Salem | Non-Veg & Biryani Catering",
        "description":
          "Nawabi Caterers offers the best non-veg catering in Salem, specializing in biryani catering, wedding catering, marriage functions, and corporate catering services.",
        "isPartOf": {
          "@type": "WebSite",
          "@id": "https://www.nawabicaterers.com/#website",
          "name": "Nawabi Caterers",
          "url": "https://www.nawabicaterers.com/"
        },
        "about": {
          "@id": "https://www.nawabicaterers.com/best-catering-services-in-salem#cateringService"
        }
      },
      {
        "@type": ["CateringService", "LocalBusiness"],
        "@id": "https://www.nawabicaterers.com/best-catering-services-in-salem#cateringService",
        "name": "Nawabi Caterers",
        "url": "https://www.nawabicaterers.com/best-catering-services-in-salem",
        "telephone": "+91 91502 99336",
        "priceRange": "₹₹",
        "description":
          "Nawabi Caterers is an outdoor catering brand from the NonVeeFoods family, specializing in non-veg catering and biryani catering for weddings, corporate events, and family celebrations in Salem and across Tamil Nadu.",
        "parentOrganization": {
          "@type": "Organization",
          "name": "NonVeeFoods"
        },
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Salem",
          "addressRegion": "Tamil Nadu",
          "addressCountry": "IN"
        },
        "areaServed": [
          "Salem",
          "Namakkal",
          "Erode",
          "Dharmapuri",
          "Krishnagiri",
          "Hosur",
          "Coimbatore",
          "Tirupur",
          "Chennai",
          "Madurai",
          "Trichy",
          "Vellore",
          "Thanjavur",
          "Kumbakonam",
          "Tirunelveli",
          "Ooty"
        ],
        "servesCuisine": ["Non-Vegetarian", "Biryani", "Indian", "South Indian"],
        "knowsAbout": [
          "Best catering services in Salem",
          "Non-veg catering in Salem",
          "Wedding catering in Salem",
          "Marriage catering in Salem",
          "Corporate catering service in Salem",
          "Biryani catering in Salem",
          "Catering services in Salem",
          "100% Halal Certified Food",
          "FSSAI Food Safety Standards"
        ],
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Karthik & Anitha"
            },
            "reviewBody":
              "Nawabi Caterers handled our wedding reception at Fairlands for over 800 guests. The mutton biryani was exceptionally fragrant, perfectly cooked, and served piping hot straight through the evening. Their outdoor kitchen setup was clean, professional, and completely stress-free for our family.",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            }
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "S. Ramesh"
            },
            "reviewBody":
              "We booked them for our annual corporate meet near Suramangalam. Food was set up exactly on schedule, the presentation suited our executive team, and the tandoori starters were a huge hit. Easily the most dependable corporate catering service in Salem.",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            }
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Mohammed Faiz"
            },
            "reviewBody":
              "We hosted a family function for 150 guests in Hasthampatti. Having 100% Halal-certified non-veg food was our top priority, and Nawabi Caterers delivered on every front. Rich authentic flavours, fresh preparation on-site, and very attentive serving staff.",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": "https://www.nawabicaterers.com/best-catering-services-in-salem#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Which is the best catering service in Salem for my event?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Start by matching the caterer to your event. If you want a non-veg or biryani-led spread for a wedding, party or corporate function in and around Salem, Nawabi Caterers is a good fit. The quickest way to know is to send us your date and guest count for a quote."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide wedding catering in Salem?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. Weddings are our biggest events. We plan the menu, cook on site and serve your guests, with biryani and non-veg dishes usually at the centre of the meal."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide marriage catering in Salem?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. We cater the full run of a marriage, including engagement, nichayathartham, the wedding and the reception, and our staff keep the food ready and the serving on time for each function."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide non-veg catering in Salem?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes, non-vegetarian food is our specialty. Chicken, mutton, biryani, gravies and rice varieties form the core of our menus, prepared with 100% Halal-certified meat and planned around your event."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide biryani catering in Salem?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. Biryani is one of our most requested services, prepared in event quantities and served hot for gatherings of all sizes."
            }
          },
          {
            "@type": "Question",
            "name": "Do you offer a corporate catering service in Salem?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. We cater office lunches, meetings, launches and staff functions, with an emphasis on punctual, organised and dependable service for a corporate setting."
            }
          },
          {
            "@type": "Question",
            "name": "Can I customise the menu?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Absolutely. Menus aren't fixed. We plan them with you around the occasion, guest count, preferences and budget. If you have specific requirements, tell us when you enquire."
            }
          },
          {
            "@type": "Question",
            "name": "Which locations do you serve?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "We are based in Salem and cater across the city and nearby areas, as well as across Tamil Nadu, including Chennai and Coimbatore. For other areas, contact us with your location and date and we will confirm availability."
            }
          },
          {
            "@type": "Question",
            "name": "Can you cater for large gatherings?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. We plan quantities and staff for large weddings, community events and mass functions, so everyone is served properly."
            }
          },
          {
            "@type": "Question",
            "name": "How do I request a quote, and how early should I book?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Send us your event date, venue, type of occasion and a rough guest count by call, WhatsApp or the enquiry form, and we will put together a quote. Booking earlier is better, especially for weddings and peak-season dates, so your date is secured and there is time to plan the menu."
            }
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>Best Catering Services in Salem | Non-Veg & Biryani Catering</title>
      <meta
        name="description"
        content="Looking for the best catering services in Salem? Nawabi Caterers offers premium non-veg catering, authentic biryani, wedding catering, and corporate catering services."
      />
      <meta
        name="keywords"
        content="Best catering services in Salem, non-veg catering in Salem, wedding catering in salem, marriage catering in salem, corporate catering service in Salem, catering services in Salem, biryani catering in Salem"
      />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="google-site-verification" content="n4A1wCQLHfRiUpKsfxTue7L9A0D-5wFSWnNuBZRJWmk" />

      {/* Canonical Tag */}
      <link rel="canonical" href="https://www.nawabicaterers.com/best-catering-services-in-salem" />

      {/* Open Graph (OG) Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Nawabi Caterers" />
      <meta property="og:title" content="Best Catering Services in Salem | Non-Veg & Biryani Catering" />
      <meta
        property="og:description"
        content="Nawabi Caterers delivers top-tier non-veg and biryani catering in Salem for weddings, corporate meets, and family celebrations. 100% Halal certified."
      />
      <meta property="og:url" content="https://www.nawabicaterers.com/best-catering-services-in-salem" />
      <meta property="og:image" content="https://www.nawabicaterers.com/images/nawabi-caterers-salem-og.jpg" />
      <meta property="og:locale" content="en_IN" />

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
};

export default SalemPageSeo;
